import styled from "styled-components";
import { StyledNode } from "../../../../../components/flowChartEditor/node/NodeStyles";

export const StyledSpecialNode = styled(StyledNode)`
  background-color: ${(props) => props.theme.colors.primary.darkest};
`;
